module.exports = __webpack_public_path__ + "static/media/hero-5.6448e545.png";